import React from 'react';
import ReferenceBrandsForm from './ReferenceBrandsForm';


const DefaultStepReferences= ({
    details,
    match,
    theme,
    selectReferences,
    selectedReferences,
    addReference,
    updateReference,
    deleteReference,
    language,
    setIsloading,
    setIsError,
    skipSection,
    }) => {
        const isShoe = false
    return(<>
        <ReferenceBrandsForm
             details={details}
             match={match}
             theme={theme}
             selectedReferences={selectedReferences}
             selectReferences={selectReferences}
             addReference={addReference}
             updateReference={updateReference}
             deleteReference={deleteReference}
             language={language}
             setIsloading={setIsloading}
             setIsError={setIsError}
             skipSection={skipSection}
             isShoe={isShoe}
            />
    </>)

}; export default DefaultStepReferences;